import(/* webpackMode: "eager", webpackExports: ["ClearHeaderAtTopOnDesktop"] */ "/vercel/path0/apps/discovericl/components/app/header-effects.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteShell"] */ "/vercel/path0/apps/discovericl/components/app/site-shell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/vercel/path0/apps/discovericl/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/discovericl/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/hooks/use-mapbox.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/hooks/use-router-info.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/hooks/use-settings.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared/hooks/use-site-info.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/atoms/a-button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/atoms/a-checkbox.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/atoms/a-hyperlink.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/atoms/a-information-popup.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/atoms/a-input.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/atoms/a-lightswitch.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/atoms/a-picture.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/atoms/a-select.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/atoms/a-svg.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/atoms/a-textarea.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/atoms/a-video.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/molecules/m-article-link.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/molecules/m-form-search.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/molecules/m-image-wrapper.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/molecules/m-comparison-table.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/molecules/m-legacy-burger-icl.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/molecules/m-modal.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/molecules/m-pagination-dots.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/molecules/m-pinned-subnav.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/molecules/m-slider-arrows.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/molecules/m-testimonial.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/molecules/m-video-modal.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/molecules/m-video-pip.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/molecules/m-video-thumbnail.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-404.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-500.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-about-video.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-article-listing.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-article-masthead.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-back-to-top.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-background-image-copy.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-background-image-list.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-centered-copy.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-comparison-table.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-contact-form.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-contact-modal.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-content-with-side-image.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-copy-block.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-counter.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-cta-box.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-cta-contact.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-custom-components-blog.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-entry-modal.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-exit-intent-modal.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-expandable-faqs.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-expanded-cta-section.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-faq-slider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-featured-items.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-find-a-doctor.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-formie.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-full-width-testimonial.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-full-width-video.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-hero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-image-copy-blocks.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-image-copy-slides.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-image-section-break.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CJotFormEmbed"] */ "/vercel/path0/packages/ui/components/organisms/c-jot-form-embed.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-kr-newsletter-modal.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-kr-newsletter.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-legacy-footer-evo.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-legacy-footer-icl.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-legacy-navigation-evo.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-legacy-navigation-icl.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-legacy-safety-info.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-locale-switcher-body.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-locale-switcher-screen.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-locale-switcher.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-masthead.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-minor-image-masthead.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-partial-text-masthead.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-photo-collage.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-preview-toast.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-procedure-steps.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-questions-and-answers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-references-modal.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-related-articles.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-simple-copy.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-small-testimonial-grid.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-split-testimonial.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-stats.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-steps.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-sticky-disclaimer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-story-gallery.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-testimonial-masthead.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-testimonials-slider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-the-footer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-the-header.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-wtw-slides.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/components/organisms/c-wysiwyg.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/svg/icons/fill/check-thin.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/svg/icons/stroke/close.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/svg/icons/stroke/phone.svg");
